<template>
  <div class="list">
    <div class="l-header">Игроки на сервере</div>
    <div class="players">
      <template v-for="[key, value] in players" :key="key">
        <Player :nickname="value.data.name" />
      </template>
    </div>
  </div>
</template>

<style lang="scss">
.list {
  max-width: 352px;
  background-color: #0e0e0f;
  border-radius: 15px;

  padding: 16px;

  .players {
    max-height: 500px;
    overflow: scroll;
  }

  .l-header {
    font-family: "Manrope";
    font-size: 16px;
    font-weight: 700;
    color: white;
  }
}
</style>

<script>
import { events } from "../../events";
import Player from "./Player.vue";

export default {
  name: "PlayerList",
  components: { Player },
  data() {
    return {
      players: new Map(),
    };
  },
  mounted() {
    events.on("map_loaded", this.onLoad);
  },
  methods: {
    onLoad({ bluemap }) {
      this.markerSet = bluemap.playerMarkerManager.getPlayerMarkerSet();
      this.syncPlayers();

      this.syncInterval = setInterval(this.syncPlayers, 1000);
    },
    syncPlayers() {
      this.players = new Map(this.markerSet.markers);
    },
  },
};
</script>
